"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeaveRoom = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _reactSdk = require("@100mslive/react-sdk");
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _DialogContent = require("../primitives/DialogContent");
var _utils = require("../common/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var LeaveRoom = function LeaveRoom() {
  var navigate = (0, _reactRouterDom.useNavigate)();
  var _useParams = (0, _reactRouterDom.useParams)(),
    sessionId = _useParams.sessionId,
    token = _useParams.token;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showEndRoomModal = _useState2[0],
    setShowEndRoomModal = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    lockRoom = _useState4[0],
    setLockRoom = _useState4[1];
  var isConnected = (0, _reactSdk.useHMSStore)(_reactSdk.selectIsConnectedToRoom);
  var permissions = (0, _reactSdk.useHMSStore)(_reactSdk.selectPermissions);
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var redirectToLeavePage = function redirectToLeavePage() {
    navigate("/consult/".concat(sessionId, "/review"), {
      replace: true
    });
  };
  var leaveRoom = function leaveRoom() {
    hmsActions.leave();
    redirectToLeavePage();
  };
  var endRoom = function endRoom() {
    hmsActions.endRoom(lockRoom, "End Room");
    redirectToLeavePage();
  };
  var isStreamKit = (0, _utils.isStreamingKit)();
  if (!permissions || !isConnected) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [permissions.endRoom ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(LeaveIconButton, {
        variant: "danger",
        "data-testid": "leave_room_btn",
        css: {
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0
        },
        onClick: leaveRoom,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
          title: "Leave Room",
          children: !isStreamKit ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.HangUpIcon, {}, "hangUp")
          }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
            gap: 2,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
              css: {
                "@md": {
                  transform: "rotate(180deg)"
                }
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ExitIcon, {}, "hangUp")
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
              css: {
                "@md": {
                  display: "none"
                },
                color: "inherit"
              },
              variant: "button",
              children: "Leave Studio"
            })]
          })
        })
      }, "LeaveRoom"), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Root, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Trigger, {
          asChild: true,
          css: {
            '&[data-state="open"]': {
              bg: "$errorDark"
            }
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuTriggerButton, {
            variant: "danger",
            "data-testid": "leave_end_dropdown_trigger",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.VerticalMenuIcon, {})
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Content, {
          css: {
            p: 0
          },
          alignOffset: -50,
          sideOffset: 10,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Item, {
            css: {
              w: "100%",
              bg: "rgba(178, 71, 81, 0.1)"
            },
            onClick: function onClick() {
              setShowEndRoomModal(true);
            },
            "data-testid": "end_room_btn",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
              gap: 4,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
                css: {
                  color: "$error"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.AlertTriangleIcon, {})
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
                direction: "column",
                align: "start",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
                  variant: "lg",
                  css: {
                    c: "$error"
                  },
                  children: "End Room for All"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
                  variant: "sm",
                  css: {
                    c: "$textMedEmp",
                    mt: "$2"
                  },
                  children: "Warning: You can\u2019t undo this action"
                })]
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Item, {
            css: {
              bg: "$surfaceDefault"
            },
            onClick: leaveRoom,
            "data-testid": "just_leave_btn",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
              gap: 4,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ExitIcon, {})
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
                direction: "column",
                align: "start",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Text, {
                  variant: "lg",
                  children: ["Leave ", isStreamKit ? "Studio" : "Room"]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
                  variant: "sm",
                  css: {
                    c: "$textMedEmp",
                    mt: "$2"
                  },
                  children: "You can always rejoin later"
                })]
              })]
            })
          })]
        })]
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(LeaveIconButton, {
      onClick: leaveRoom,
      variant: "danger",
      "data-testid": "leave_room_btn",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
        title: "Leave Room",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
          children: isStreamKit ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
            css: {
              "@md": {
                transform: "rotate(180deg)"
              }
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ExitIcon, {})
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.HangUpIcon, {}, "hangUp")
        })
      })
    }, "LeaveRoom"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.Root, {
      open: showEndRoomModal,
      onOpenChange: function onOpenChange(value) {
        if (!value) {
          setLockRoom(false);
        }
        setShowEndRoomModal(value);
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DialogContent.DialogContent, {
        title: "End Room",
        Icon: _reactIcons.HangUpIcon,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogContent.DialogCheckbox, {
          id: "lockRoom",
          title: "Disable future joins",
          value: lockRoom,
          onChange: setLockRoom
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogContent.DialogRow, {
          justify: "end",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Button, {
            variant: "danger",
            onClick: endRoom,
            "data-testid": "lock_end_room",
            children: "End Room"
          })
        })]
      })
    })]
  });
};
exports.LeaveRoom = LeaveRoom;
var LeaveIconButton = (0, _reactUi.styled)(_reactUi.IconButton, {
  color: "$white",
  h: "$14",
  px: "$8",
  r: "$1",
  bg: "$error",
  "&:not([disabled]):hover": {
    bg: "$errorTint"
  },
  "&:not([disabled]):active": {
    bg: "$errorTint"
  },
  "@md": {
    px: "$4",
    mx: 0
  }
});
var MenuTriggerButton = (0, _reactUi.styled)(LeaveIconButton, {
  borderLeft: "1px solid $errorDark",
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  px: "$3",
  "@md": {
    px: "$2"
  }
});